/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Text from '../Text/Text';
import Statement from '../Statement/Statement';
import './StatementText.scss';

/**
 * This is the StatementText component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function StatementText({ statement, text, dropcap }) {
  return (
    <div className="block statement-text">
      <Text dropcap={dropcap}>{text}</Text>
      <Statement>{statement}</Statement>
    </div>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
StatementText.propTypes = {
  dropcap: PropTypes.bool,
  statement: PropTypes.string,
  text: PropTypes.string,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
StatementText.defaultProps = {
  dropcap: false,
};

export default StatementText;
